import React from "react";
import { Badge, colors } from "../design/badge";

interface CaseStatusBadgeProps {
  status: string;
}

const CaseStatusBadge: React.FC<CaseStatusBadgeProps> = ({ status }) => {
  let color;
  let title;

  switch (status) {
    case "open":
      color = "green"; // Indicates success or completion
      title = "Open";
      break;
    case "closed":
      color = "red"; // Signifies an alert or problem
      title = "Closed";
      break;
    default:
      color = "yellow"; // Default color if status is unknown
      title = status ?? "Unknown";
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default CaseStatusBadge;
